module.exports = __webpack_public_path__ + "img/start_plan.5293e8df.svg";